import { CurrencyValue } from './CurrencyValue';

export const StatCard = ({
  title,
  value,
  icon: Icon,
  hint,
  loading = false,
  tone = 'brand',
  primaryLabel,
  secondaryLabel,
  secondaryValue,
}) => {
  const toneClass =
    tone === 'danger'
      ? 'bg-red-50 text-red-700 dark:bg-red-500/10 dark:text-red-300'
      : tone === 'success'
      ? 'bg-green-50 text-green-700 dark:bg-green-500/10 dark:text-green-300'
      : tone === 'warning'
      ? 'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300'
      : 'bg-[var(--brand-soft)] text-[var(--brand)]';

  return (
    <div className='rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-panel)] p-5 shadow-sm'>
      <div className='flex items-start justify-between gap-4'>
        <div>
          <p className='text-sm font-semibold text-[var(--text-secondary)]'>{title}</p>
          {loading ? (
            <div className='mt-3 h-8 w-36 animate-pulse rounded bg-slate-200 dark:bg-slate-700' />
          ) : (
            <p className='mt-2 text-2xl font-bold text-[var(--text-primary)]'>
              <CurrencyValue value={value} />
            </p>
          )}
          {primaryLabel && !loading && <p className='mt-1 text-xs font-medium text-[var(--text-muted)]'>{primaryLabel}</p>}
        </div>
        {Icon && (
          <span className={`flex h-11 w-11 items-center justify-center rounded-[var(--radius-md)] ${toneClass}`}>
            <Icon aria-hidden='true' />
          </span>
        )}
      </div>
      {secondaryLabel && (
        <div className='mt-4 border-t border-[var(--border-subtle)] pt-3'>
          <p className='text-xs font-medium text-[var(--text-muted)]'>{secondaryLabel}</p>
          {loading ? (
            <div className='mt-2 h-5 w-28 animate-pulse rounded bg-slate-200 dark:bg-slate-700' />
          ) : (
            <CurrencyValue value={secondaryValue} className='mt-1 block text-base font-semibold text-[var(--text-secondary)]' />
          )}
        </div>
      )}
      {hint && <p className='mt-4 text-xs text-[var(--text-muted)]'>{hint}</p>}
    </div>
  );
};
